import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18N, I18NContext } from 'commons';

const SaveButton = ({ onClick, type, ebTestValue, hasContinue }) => {
  const i18n = useContext(I18NContext);
  return (
    <div className={hasContinue ? 'col-md-8' : 'col-md-7'}>
      <button
        className="btn btn-primary btn-block"
        type={type}
        onClick={onClick}
        eb-test={ebTestValue}
        value={i18n[hasContinue ? 'button.save&continue' : 'button.save']}
      >
        <I18N>
          {hasContinue ? 'button.save&continue' : 'button.save'}
        </I18N>
      </button>
    </div>
  );
};

SaveButton.propTypes = {
  type: PropTypes.string,
  onClick: PropTypes.func,
  ebTestValue: PropTypes.string.isRequired,
  hasContinue: PropTypes.bool,
};

SaveButton.defaultProps = {
  onClick: () => { },
  type: 'button',
  hasContinue: true
};

export default SaveButton;
